import React from "react";
import { Link } from "react-router-dom";
import { EmptyState, PortalLoading, StatusBadge, StudentPageHeader, useStudentPortal } from "./studentPortalUtils";

function StudentResultsPage() {
  const { data, loading, reload } = useStudentPortal("student-portal/results/");
  if (loading && !data) return <PortalLoading />;

  const sessions = data?.sessions || [];

  return (
    <div className="container-fluid py-4">
      <StudentPageHeader
        title="My Results & Report Cards"
        subtitle="View published marks and download printable report cards when they are available."
        icon="bi-journal-check"
        actions={<button className="btn btn-light border" onClick={reload}>Refresh</button>}
      />

      {sessions.length === 0 ? (
        <div className="card border-0 shadow-sm"><EmptyState title="No published results" /></div>
      ) : (
        sessions.map((session) => (
          <div className="card border-0 shadow-sm mb-3" key={session.id}>
            <div className="card-header bg-white d-flex flex-wrap justify-content-between align-items-center gap-2">
              <div>
                <strong>{session.name}</strong>
                <div className="small text-muted">{session.academic_year} · {session.term || ""}</div>
              </div>
              <div className="d-flex flex-wrap align-items-center gap-2">
                <StatusBadge value={session.can_view ? "Available" : "Restricted"} />
                {session.can_download_report && (
                  <Link to={`/student/results/report/${session.id}`} className="btn btn-sm btn-success">
                    <i className="bi bi-download me-1"></i>
                    Download Report
                  </Link>
                )}
              </div>
            </div>

            <div className="card-body">
              {!session.can_view ? (
                <div className="alert alert-warning mb-0">{session.message}</div>
              ) : session.marks.length === 0 ? (
                <EmptyState title="No marks recorded" />
              ) : (
                <div className="table-responsive">
                  <table className="table align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Subject</th>
                        <th>Assessment</th>
                        <th>Score</th>
                        <th>%</th>
                        <th>Grade</th>
                        <th>Remark</th>
                      </tr>
                    </thead>
                    <tbody>
                      {session.marks.map((mark) => (
                        <tr key={mark.id}>
                          <td>{mark.subject}</td>
                          <td>{mark.assessment_type}</td>
                          <td>{mark.raw_score} / {mark.max_score}</td>
                          <td>{mark.percentage}</td>
                          <td><StatusBadge value={mark.grade} /></td>
                          <td>{mark.remark || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default StudentResultsPage;
